import React from "react";
import Contact from "./containers/Contact";
import About from "./containers/About";
import AditionalInfo from "./containers/AditionalInfo";
import Social from "./containers/Social";
import Copyright from "./containers/Copyright";
import "./Footer.scss";

function Footer({ sections }) {
  return (
    <footer>
      <div className="footer-wrapper">
        <div className="footer-background">
          <div className="footer-logoContainer">
            <img className="footer-logo" src='/img/logo/w.svg' alt='logo' />
          </div>
          <div className="FooterDetails">
            <Contact />
            {sections !== null ? <About sections={sections}/> : <p> </p>}
            <AditionalInfo />
            <Social />
          </div>
        </div>
        <Copyright />
      </div>
    </footer>
  );
}

export default Footer;